import companyListReducer from "../../slices/company/company/CompanyList"
import companyDetailsReducer from "../../slices/company/company/CompanyDetails"
import companyUserListReducer from "../../slices/company/company_user/CompanyUserList"
import companyUserDetailsReducer from "../../slices/company/company_user/CompanyUserDetails"
import itAdminListReducer from "../../slices/company/it_admin/ItAdminList"
import itAdminDetailsReducer from "../../slices/company/it_admin/ItAdminDetails"
import vendorListReducer from "../../slices/company/vendor/VendorList"
import vendorDetailsReducer from "../../slices/company/vendor/VendorDetails"
import vendorEmployeeListReducer from "../../slices/company/vendor_employee/VendorEmployeeList"
import vendorEmployeeDetailsReducer from "../../slices/company/vendor_employee/VendorEmployeeDetails"
import instituteOnboardingListReducer from "../../slices/company/institute_onboarding/InstituteOnboardingList"
import instituteOnboardingDetailsReducer from "../../slices/company/institute_onboarding/InstituteOnboardingDetails"
import branchOfficeListReducer from "../../slices/company/branch_office/BranchOfficeList"
import branchOfficeDetailsReducer from "../../slices/company/branch_office/BranchOfficeDetails"
import instituteBranchOfficeListReducer from "../../slices/company/branch_office/InstituteBranchOfficeList"
import branchCourseListReducer from "../../slices/company/branch_course/BranchCourseList"
import branchCourseDetailsReducer from "../../slices/company/branch_course/BranchCourseDetails"


const companyReducer = {
    companyList: companyListReducer,
    companyDetails: companyDetailsReducer,
    companyUserList: companyUserListReducer,
    companyUserDetails: companyUserDetailsReducer,
    itAdminList: itAdminListReducer,
    itAdminDetails: itAdminDetailsReducer,
    vendorList: vendorListReducer,
    vendorDetails: vendorDetailsReducer,
    vendorEmployeeList: vendorEmployeeListReducer,
    vendorEmployeeDetails: vendorEmployeeDetailsReducer,
    instituteOnboardingList: instituteOnboardingListReducer,
    instituteOnboardingDetails: instituteOnboardingDetailsReducer,
    branchOfficeList: branchOfficeListReducer,
    branchOfficeDetails: branchOfficeDetailsReducer,
    instituteBranchOfficeList: instituteBranchOfficeListReducer,
    branchCourseList: branchCourseListReducer,
    branchCourseDetails: branchCourseDetailsReducer,

}

export default companyReducer
